import React from 'react';
import { Theme } from './context/Theme.jsx';
import RouteComp from './components/RouteComp.jsx';
import { BrowserRouter } from 'react-router-dom';
const App = () => {
  return (
    <BrowserRouter>
      <Theme>
        <RouteComp />
      </Theme>
    </BrowserRouter>

  )
}

export default App;